import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';

(function($) {
    $(function() {
        addTelephoneInputValidation()
    });

    $(document).ajaxStop(function() {
        addTelephoneInputValidation()
    });

    function addTelephoneInputValidation() {
        if ($('.iti__flag-container').length) return;
        
        var phoneField = $('#mm_field_phone');

        if (!phoneField.length) {
            phoneField = $('#mm-myaccount-account-details-dialog #mm_phone');
    
            if (!phoneField.length) return;
        }
    
    
        phoneField.after(`<div id="valid-msg" class="hide">✓ ${localization.valid}</div> <div id="error-msg" class="hide"></div>`);
    
        $(phoneField).data('storage', false);
    
        var errorMsg = $("#error-msg");
        var validMsg = $("#valid-msg");
        var errorMap = [
            localization.invalidNumber,
            localization.invalidCountryCode,
            localization.tooShort,
            localization.tooLong,
            localization.invalidNumber
        ];
        var iti = intlTelInput(phoneField[0], {
    
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@14.0.3/build/js/utils.min.js",
    
            initialCountry: "auto",
    
            nationalMode: true,
    
            geoIpLookup: function(callback) {
                $.get('https://ipinfo.io', function() {}, "jsonp").always(function(resp) {
                    var countryCode = (resp && resp.country) ? resp.country : "";
    
                    callback(countryCode);
                });
            },
            customPlaceholder: function(countryPlaceholder) {
                return localization.yourTelephoneNumber;
            },
            autoPlaceholder: 'aggressive'
        });
    
        function reset() {
            //$(phoneField).removeClass("error");
            $(errorMsg).text();
            $(errorMsg).addClass("hide").removeClass("errorMsg");
            $(validMsg).addClass("hide").removeClass("validMsg");
        }
    
        // on blur: validate
    
        $(phoneField).on('blur', function() {
            reset();
    
            if ($(phoneField).val().trim()) {
                if (iti.isValidNumber()) {
                    $('[href=\"javascript:myaccount_js.updateMemberData(335, \'account-details\');\"], [href=\"javascript:mmjs.checkout(true);\"]').removeClass('wpk-disabled');
    
                    var intFormat = iti.getNumber();
    
                    $(phoneField).val(intFormat);
                    $(validMsg).removeClass("hide").addClass("validMsg");
                    $(phoneField).css({"border-color":"#4a8920", "border-width":"3px"});
                } else {
                    $('[href=\"javascript:myaccount_js.updateMemberData(335, \'account-details\');\"], [href=\"javascript:mmjs.checkout(true);\"]').addClass('wpk-disabled');
                    $(phoneField).css({"border-color":"#b91517", "border-width":"3px"});
    
                    var errorCode = iti.getValidationError();
    
                    $(errorMsg).text(errorMap[errorCode]);
                    $(errorMsg).removeClass("hide").addClass("errorMsg");
                }
            }
        });
    
        // on keyup / change flag: reset
    
        $(phoneField).on("change keyup", function() {
            reset();
        });
    }
})(jQuery);